export default {
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },

        ratio: {
            type: String,
            default: '181:240',
            required: false
        }
    }
}